import { render, staticRenderFns } from "./cate-tip.vue?vue&type=template&id=cd8bfdb8"
import script from "./cate-tip.vue?vue&type=script&lang=js"
export * from "./cate-tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports